/**
 * 动态表情，TODO: 替换自己的url
 * https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/0.gif
 */
const emojis = {
    "[微笑]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/100.gif'>",
    "[撇嘴]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/101.gif'>",
    "[色]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/102.gif'>",
    "[发呆]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/103.gif'>",
    "[得意]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/104.gif'>",
    "[流泪]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/105.gif'>",
    "[害羞]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/106.gif'>",
    "[闭嘴]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/107.gif'>",
    "[睡]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/108.gif'>",
    "[大哭]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/109.gif'>",

    "[尴尬]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/110.gif'>",
    "[发怒]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/111.gif'>",
    "[调皮]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/112.gif'>",
    "[呲牙]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/113.gif'>",
    "[惊讶]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/114.gif'>",
    "[难过]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/115.gif'>",
    "[酷]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/116.gif'>",
    "[冷汗]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/117.gif'>",
    "[抓狂]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/118.gif'>",
    "[吐]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/119.gif'>",

    "[偷笑]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/120.gif'>",
    "[可爱]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/121.gif'>",
    "[白眼]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/122.gif'>",
    "[傲慢]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/123.gif'>",
    "[饥饿]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/124.gif'>",
    "[困]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/125.gif'>",
    "[惊恐]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/126.gif'>",
    "[流汗]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/127.gif'>",
    "[憨笑]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/128.gif'>",
    "[悠闲]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/129.gif'>",

    "[奋斗]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/130.gif'>",
    "[咒骂]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/131.gif'>",
    "[疑问]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/132.gif'>",
    "[嘘]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/133.gif'>",
    "[晕]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/134.gif'>",
    "[折磨]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/135.gif'>",
    "[衰]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/136.gif'>",
    "[骷髅]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/137.gif'>",
    "[敲打]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/138.gif'>",
    "[再见]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/139.gif'>",

    "[擦汗]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/140.gif'>",
    "[抠鼻]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/141.gif'>",
    "[鼓掌]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/142.gif'>",
    "[糗大了]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/143.gif'>",
    "[坏笑]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/144.gif'>",
    "[左哼哼]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/145.gif'>",
    "[右哼哼]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/146.gif'>",
    "[哈欠]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/147.gif'>",
    "[鄙视]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/148.gif'>",
    "[委屈]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/149.gif'>",

    "[快哭了]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/150.gif'>",
    "[阴险]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/151.gif'>",
    "[亲亲]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/152.gif'>",
    "[吓]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/153.gif'>",
    "[可怜]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/154.gif'>",
    "[菜刀]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/155.gif'>",
    "[西瓜]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/156.gif'>",
    "[啤酒]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/157.gif'>",
    "[篮球]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/158.gif'>",
    // "[乒乓]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/159.gif'>",

    "[咖啡]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/160.gif'>",
    "[饭]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/161.gif'>",
    "[猪头]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/162.gif'>",
    "[玫瑰]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/163.gif'>",
    "[凋谢]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/164.gif'>",
    "[嘴唇]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/165.gif'>",
    "[爱心]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/166.gif'>",
    "[心碎]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/167.gif'>",
    "[蛋糕]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/168.gif'>",
    // "[闪电]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/169.gif'>",

    "[炸弹]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/170.gif'>",
    "[刀]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/171.gif'>",
    "[足球]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/172.gif'>",
    "[礼物]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/177.gif'>",
    "[拥抱]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/178.gif'>",
    "[强]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/179.gif'>",

    "[弱]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/180.gif'>",
    "[握手]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/181.gif'>",
    "[胜利]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/182.gif'>",
    "[抱拳]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/183.gif'>",
    "[勾引]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/184.gif'>",
    "[拳头]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/185.gif'>",
    "[差劲]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/186.gif'>",
    "[爱你]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/187.gif'>",
    "[No]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/188.gif'>",
    "[OK]": "<img src='https://chainsnow.oss-cn-shenzhen.aliyuncs.com/emojis/gif/189.gif'>",
};

/**
 * 符号表情
 */
const symbol = [
    "😠", "😩", "😲", "😞", "😵", "😰", "😒", "😍", "😤", "😜", "😝", "😋", "😘", "😚", "😷",
    "😳", "😃", "😅", "😆", "😁", "😂", "😊", "☺", "😄", "😢",
    "😭", "😨", "😣", "😡", "😌", "😖", "😔", "😱", "😪", "😏", "😓", "😥", "😫", "😉",
    "✊", "✋", "✌", "👊", "👍", "☝", "👆", "👇", "👈", "👉",
    "👋", "👏", "👌", "👎"
];

const emojisKeys = Object.keys(emojis);

export const emojiList = {
    symbol,
    emojis
}

const regEmoji = emojisKeys.map((value) => '|\\' + value).join('').replace('|', '')

/**
 * 替换表情文字
 * 
 * @param {String} content 需要替换的字符串
 */
export function textReplaceEmoji(content) {
    return content.replace(new RegExp(`(${regEmoji})`, 'gi'), ($0, $1) => {
        return emojis[$1];
    });
}